/**
 * Created by mukund on 12/4/16.
 */

'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('lmsEmbedPlay', {
                parent: 'site',
                url: '/lms/embed/play/:collectionId/:assetId/:batchId/:authToken',
                data: {
                    roles: [],
                    pageTitle: 'lms-embed-play.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/lms/embed/play/templates/lms-embed-play.html',
                        controller: 'LMSEmbedPlayController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('lms-embed-play');
                        return $translate.refresh();
                    }]
                }
            });
    });
